import { DateTime } from 'luxon'

export const createInitialState = (
  params = {},
  client = null,
  defaultAuthType = 'none',
) => ({
  // Authentication
  authType: defaultAuthType,
  authTypes: [],
  password: '',
  prompt: '',
  selectedQuestion: 'dssn',
  secretQuestions: {},
  userSecretQuestionList: null,

  // Client/User Selection
  clientId: client ? client._id : null,
  userId: null,
  _personal: params.userId ? `personal${params.userId}` : null,

  // Folder Selection
  selectedFolder: {
    _client: params.clientId || null,
    _personal: params.userId || '',
    _id: params.folderId || '',
  },

  // Request Template
  selectedRequestTemplate: null,
  templateDocuments: [],

  // Settings
  sN_upload: true,
  expires: false,
  expireDate: DateTime.local().plus({ days: 30 }).toMillis(),
  addInstructions: false,
  instructions: '',

  // Email Settings
  sendEmails: false,
  recipients: [],
  emailMessage: '',
  receiveEmails: false,
  receivers: [],
  selectedStaff: '',
  emailResults: {},

  // UI State
  copySuccess: false,
  submitting: false,

  // Task builder state (templates)
  dateRange: { from: null, to: null },
  dueDate: null,
  selectedDocuments: [],
  otherInputs: [''],
  perDocumentDates: {},
  perOtherInputDates: {},
  specialInstructions: '',
  assignees: [
    { firstname: '', lastname: '', username: '', createContact: false },
  ],
})

export const initialState = createInitialState()
